import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo_only.svg'


const _hoisted_1 = { class: "bg-white shadow-md" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "justify-between" }
const _hoisted_4 = { class: "py-4 flex w-full items-center" }
const _hoisted_5 = {
  key: 0,
  class: "hidden ml-auto md:flex space-x-6"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "lds-ellipsis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feature = _resolveComponent("vue-feature")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "flex items-center",
            to: {name: 'home'}
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                class: "w-6 h-6",
                src: _imports_0,
                alt: "avored e commerce"
              }, null, -1),
              _createElementVNode("span", { class: "text-2xl ml-3 text-red-700" }, "AvoRed", -1)
            ]))]),
            _: 1
          }),
          (!_ctx.fetching)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.allCategory, (category, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `category-link-${index}`
                  }, [
                    _createVNode(_component_router_link, {
                      class: "text-gray-600 hover:text-red-500 font-semibold",
                      to: {name: 'category', params: {slug: category.slug}}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(category.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128)),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "self-center hover:text-red-500",
                    to: {name: 'account'}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vue_feature, { type: "user" })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, {
                    class: "self-center hover:text-red-500",
                    to: {name: 'cart'}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vue_feature, { type: "shopping-cart" })
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.isAuth)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        class: "self-center hover:text-red-500",
                        to: {name: 'logout'}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vue_feature, { type: "log-out" })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("div", null, null, -1),
                _createElementVNode("div", null, null, -1),
                _createElementVNode("div", null, null, -1),
                _createElementVNode("div", null, null, -1)
              ]))]))
        ])
      ])
    ])
  ]))
}